/**
 * Formats first and last names
 *
 * @param person - Customer, Agent, or Loan Officer object
 * @returns - Formatted name or undefined if no first or last name
 */
const formatName = (
  person?: Customer | Agent | LoanOfficer,
): string | undefined => {
  if (!person) {
    return undefined;
  }

  const { firstname, lastname } = person;

  if (firstname || lastname) {
    return `${firstname} ${lastname}`.trim();
  }

  return undefined;
};

export default formatName;
